import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { getBuybackHistory } from '~/apis'
import DataContainer from '~/components/DataContainer'
import { formatNumber, toBigNumberWithDecimal } from '~/utils/numbers'
import { StyledLonBuybackContainer, StyledBuybackContainer } from './styled'

const LonBuyBackArea: React.FC = () => {
  const { t } = useTranslation()
  const { data: buybackHistory = [] } = useSWR(
    'getBuybackHistory',
    getBuybackHistory,
  )
  const totalManualBuybackAmount = buybackHistory.reduce(
    (total, item) => total + item.buybackAmount,
    0,
  )
  // @notice: 回购机制调整为链下回购后累计回购数量= subgraph 提供的 totalLonStakingAmount + totalTreasuryAmount 再加上后端 API 提供手动回购的数量。链下回购后 subgraph 不更新，subgraph 部份的数值可直接写死
  const totalMintedAmount = '19384070125177573313121662'
  const totalAmount = toBigNumberWithDecimal(totalMintedAmount, 18).plus(
    totalManualBuybackAmount,
  )

  return (
    <StyledLonBuybackContainer>
      <h4 className="title">{t('buyback_subtitle_buyback')}</h4>
      <StyledBuybackContainer>
        <DataContainer
          dataTitle={t('buyback_card_buyback_amount')}
          description={`${formatNumber(totalAmount, 2)} LON`}
          title={t('buyback_tips_buyback_amount')}
        />
        <DataContainer
          dataTitle={t('buyback_card_scaleindex')}
          description="0"
          title={t('buyback_tips_scaleindex')}
        />
      </StyledBuybackContainer>
    </StyledLonBuybackContainer>
  )
}

export default LonBuyBackArea
